<template>
  <base-layout>
    <template v-slot:header>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Nova promocija
      </h1>
    </template>
    <template v-slot:default>
      <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Mesto i vreme održavanja promocije
            </h3>
            <p class="mt-1 max-w-4xl text-sm text-gray-500">
              Odaberi mesto i vreme održavanja promocije.
            </p>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" v-if="promotions.length">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="sm:pl-6 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Mesto, vreme i status
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">

                  <tr class="hover:bg-gray-50 cursor-pointer" v-for="(promotion, index) in promotions" :key="index">
                    <Promotion
                        :name="promotion.location"
                        :date="promotion.date"
                        :status="promotion.status"
                        :type="promotion.type.name"
                        :promotionId="promotion.id"
                        :id="promotion.type.id"
                    />
                  </tr>

                </tbody>
              </table>
            </div>
            <div v-else>
              <p class="text-lg leading-6 font-medium text-gray-900" style="line-height: 100px;">Nema zakazanih promocija za današnji dan.</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import NewPromotion from './NewPromotion';
export default NewPromotion;
</script>
